import { Switch as NextSwitch } from "@heroui/react";
import { withFormComponent } from "./hoc";

// 设置Switch组件的displayName
NextSwitch.displayName = "HeroUI.Switch";

export const Switch = withFormComponent(NextSwitch); 